/**
 * Configuración centralizada para Facebook Pixel
 * 
 * Este archivo contiene la configuración necesaria para el Facebook Pixel,
 * lo que facilita actualizar el ID del pixel y otras configuraciones desde un solo lugar.
 */

// El ID de tu Facebook Pixel - IMPORTANTE: Reemplaza con tu ID real
export const PIXEL_ID = '665581965819767';

// Configuración general para Facebook Pixel
export const PIXEL_CONFIG = {
  // Campos de usuario que pueden ser enviados en los eventos
  USER_FIELDS: {
    em: 'email',        // Email (hash automático por fbq)
    ph: 'phone',        // Teléfono (hash automático por fbq)
    fn: 'first_name',   // Primer nombre
    ln: 'last_name',    // Apellido
    ge: 'gender',       // Género
    db: 'date_of_birth', // Fecha de nacimiento
    ct: 'city',         // Ciudad
    st: 'state',        // Estado/Provincia
    zp: 'zip',          // Código postal
    country: 'country'  // País
  },
  
  // Parámetros comunes para eventos de conversión
  COMMON_PARAMS: {
    currency: 'MXN',    // Moneda predeterminada
    language: 'es_MX'   // Idioma predeterminado
  }
}; 